import Navbar from "../components/Navbar.js";
import Hero from "../components/Hero.js";
import Trip from "../components/Trip.js";
import Footer from "../components/Footer.js";
import Destination from "../components/Destination.js";
import heroImage from "../assets/12.jpg";

function Home(params) {
  return (
    <>
      <Navbar />
      <Hero
        cName="hero"
        heroImg={heroImage}
        title="Your Journey Your Story"
        text="Choose Your Favorite Destination"
        url="/about"
        buttonText="Travel Plan"
        url="/"
        btnClass="show"
      />
      <Destination/>
      <Trip/>
      <Footer/>
    </>
  );
}

export default Home;
